import { BoxProps } from '../BoxNew'
import { TextProps } from '../TextNew'

const NOTIFICATION_CONTENT_MARGIN = 10
const NOTIFICATION_MODAL_WIDTH = '100%'

const defaultNotificationPositionStyle = {
  modal: {
    flex: 1,
  } as BoxProps,
  contentContainer: {
    margin: NOTIFICATION_CONTENT_MARGIN,
    flexDirection: 'row',
  } as BoxProps,
  actionContainer: {
    flex: 1,
    alignItems: 'flex-end',
  } as BoxProps,
  text: {} as TextProps,
}

const position = {
  top: {
    ...defaultNotificationPositionStyle,
    modal: {
      flex: 1,
    } as BoxProps,
    superContainer: {
      flex: 1,
      flexDirection: 'column-reverse',
    } as BoxProps,
  },
  bottom: {
    ...defaultNotificationPositionStyle,
    modal: {
      flex: 1,
      justifyContent: 'flex-end',
    } as BoxProps,
    superContainer: {
      flex: 1,
      flexDirection: 'column',
    } as BoxProps,
  },
  center: {
    ...defaultNotificationPositionStyle,
    modal: {
      justifyContent: 'center',
    } as BoxProps,
    superContainer: {
      flex: 1,
      justifyContent: 'center',
    } as BoxProps,
  },
}

const defaultNotificationTypeStyle = {
  modal: {
    padding: 8,
    width: NOTIFICATION_MODAL_WIDTH,
    backgroundColor: 'PRIMARY',
  } as BoxProps,
  contentContainer: {
    paddingVertical: NOTIFICATION_CONTENT_MARGIN,
    alignItems: 'center',
    flexDirection: 'row',
  } as BoxProps,
  actionContainer: {
    flex: 1,
    alignItems: 'flex-end',
  } as BoxProps,
  action: {
    color: 'GREEN',
    fontSize: 'FONT_SIZE_MEDIUM',
  } as TextProps,
  text: {
    color: 'WHITE',
    fontSize: 'FONT_SIZE_MEDIUM',
    marginLeft: NOTIFICATION_CONTENT_MARGIN,
  } as TextProps,
  iconColor: 'WHITE',
  iconFont: 'FONT_SIZE_MEDIUM',
  superContainer: {
    flex: 1,
    flexDirection: 'column',
  } as BoxProps,
  position: { ...position },
}

const notificationType = {
  positive: {
    ...defaultNotificationTypeStyle,
  },
  negative: {
    ...defaultNotificationTypeStyle,
    modal: {
      ...defaultNotificationTypeStyle.modal,
      width: NOTIFICATION_MODAL_WIDTH,
      backgroundColor: 'ERROR',
    } as BoxProps,
  },
  neutral: {
    ...defaultNotificationTypeStyle,
    modal: {
      ...defaultNotificationTypeStyle.modal,
      width: NOTIFICATION_MODAL_WIDTH,
      backgroundColor: 'GREEN',
    } as BoxProps,
    action: {
      color: 'PRIMARY',
      fontSize: 'FONT_SIZE_MEDIUM',
    } as TextProps,
  },
}

export { notificationType }
